import tippy from 'tippy.js';

const wiredHints        = new WeakSet();
const openedSourceFiles = new WeakMap();

const buildMessage = hint => {
    const select = hint.querySelector('select');

    if (select.value === hint.dataset.format) {
        return hint.dataset.formatMessage;
    }

    const selectedLabel = select.selectedOptions[0]?.textContent.trim() ?? select.value;

    return hint.dataset.otherFormatMessage.replace('%s', selectedLabel);
};

const openFirstVisibleHint = mappingStep => {
    const sourceFilePath = mappingStep.querySelector('input[name="sourceFilePath"]').value;

    if (openedSourceFiles.get(mappingStep) === sourceFilePath) {
        return;
    }

    const firstVisibleHint = [...mappingStep.querySelectorAll('[data-component="date-format-hint"]')]
        .find(hint => hint.offsetParent !== null);

    if (!firstVisibleHint) {
        return;
    }

    openedSourceFiles.set(mappingStep, sourceFilePath);

    firstVisibleHint._tippy.show();
};

export const updateDateFormatHint = select => {
    const hint = select.closest('[data-component="date-format-hint"]');

    hint?._tippy?.setContent(buildMessage(hint));
};

export const initializeDateFormatHints = root => {
    root.querySelectorAll('[data-component="date-format-hint"]').forEach(hint => {
        if (wiredHints.has(hint)) {
            return;
        }

        wiredHints.add(hint);

        tippy(hint, {content: buildMessage(hint), maxWidth: 320, placement: 'bottom'});
    });

    const mappingStep = root.closest?.('[data-wizard-step="mapping"]')
        ?? root.querySelector('[data-wizard-step="mapping"]');

    if (mappingStep) {
        openFirstVisibleHint(mappingStep);
    }
};
